import React from "react";
import { CallbackComponent } from "redux-oidc";
import userManager from "../userManager";
import { AfterKDlogin } from "../KDgeneric"


class CallbackPageKD extends React.Component {
  render() {
    AfterKDlogin();
    document.title = 'Neurite login';
    var link = document.querySelector("link[rel~='icon']");
    link.href = "/Ilusiona_fav.png";
    return (
      <div>
        <span>Login ok. Puede acceder al área corportativa.</span>
      </div>
    );
  }
}

export default CallbackPageKD; 